import React from 'react';
import { UserGroupIcon } from '@heroicons/react/outline';

const ReferralMetrics = ({ referralCount = 0 }) => {
  const REFERRALS_PER_MONTH = 5;
  const earnedMonths = Math.floor(referralCount / REFERRALS_PER_MONTH);
  const progress = referralCount % REFERRALS_PER_MONTH;
  const progressPct = (progress / REFERRALS_PER_MONTH) * 100;

  return (
    <div className="bg-base-white w-full rounded-lg shadow-sm border border-grey-200 p-3">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-sm font-semibold text-grey-700">Referral Rewards</h2>
        <div className="flex items-center gap-1.5">
          <UserGroupIcon className="w-4 h-4 text-grey-400" />
          <span className="text-xs font-medium text-grey-500">{referralCount} referrals</span>
        </div>
      </div>

      {/* Progress bar */}
      <div className="mb-2">
        <div className="flex justify-between items-center mb-1.5">
          <span className="text-xs text-grey-600 font-medium">Progress to next free month</span>
          <span className="text-xs font-semibold text-grey-700">{progress}/5</span>
        </div>
        <div className="h-2 bg-grey-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary-600 rounded-full transition-all duration-500"
            style={{ width: `${progressPct}%` }}
          />
        </div>
      </div>

      {/* Earned months */}
      {earnedMonths > 0 ? (
        <div className="flex items-center gap-2 mt-3 px-3 py-2 bg-primary-50 border border-primary-100 rounded-lg">
          <span className="text-base">🎁</span>
          <p className="text-xs font-semibold text-primary-700">
            {earnedMonths} free month{earnedMonths !== 1 ? 's' : ''} earned
          </p>
        </div>
      ) : (
        <p className="text-[11px] text-grey-400 mt-1">
          Refer {5 - progress} more organizer{5 - progress !== 1 ? 's' : ''} to earn 1 free month
        </p>
      )}
    </div>
  );
};

export default ReferralMetrics;
